import * as angular from 'angular';

import {transactions} from './transactions';

export const transactionsModule = 'transactions'

angular
  .module(transactionsModule, [])
  .component('transactions', transactions)



// WEBPACK FOOTER //
// ./src/app/transactions/transactions.index.ts